import { AxiosObj } from "../../Configurations/axios-setup";
import { fetchAccountId, fetchSubscriberId, fetchSubscriptionId } from "../../../utils/GetAccountDetails"
import UpdateHeaders from "../../Configurations/UpdateHeaders";

class DpodAppFlyteApi {

    constructor() {
        this.accountId = null;
        this.subscribeId = null;
        this.subscriptionId = null;
    }

    async initialize() {
        this.accountId = await fetchAccountId();
        this.subscriberId = await fetchSubscriberId();
        this.subscriptionId = await fetchSubscriptionId();
    }

    addData = async (reqObj) => {
        await this.initialize();
        return AxiosObj.post(`/${this.accountId}/api/collection/${this.accountId}/user/private/cm/v1/${window.__ENV__.AMEYA_COLLECTIONS_SCHEMA_ID}/ameya_analytics_datasetss`, reqObj)
    }

    getAll = async (last_evaluated_key, project_id) => {
        await this.initialize();
        const queryObj = [{
            field_name: "payload.project_id",
            field_value: project_id,
            operator: "eq"
        }]
        const filter = encodeURIComponent(JSON.stringify(queryObj))
        return AxiosObj.get(`/${this.accountId}/api/collection/${this.accountId}/user/private/cm/v1/${window.__ENV__.AMEYA_COLLECTIONS_SCHEMA_ID}/ameya_analytics_datasetss?filters=${filter}&last_evaluated_key=${last_evaluated_key}&page_size=1000&include_detail=false`)
    }

    delete = async (item_Id) => {
        await this.initialize();
        return AxiosObj.delete(`/${this.accountId}/api/collection/${this.accountId}/user/private/cm/v1/${window.__ENV__.AMEYA_COLLECTIONS_SCHEMA_ID}/ameya_analytics_datasets/${item_Id}`)
    }

    getById = async (item_Id) => {
        await this.initialize();
        return AxiosObj.get(`/${this.accountId}/api/collection/${this.accountId}/user/private/cm/v1/${window.__ENV__.AMEYA_COLLECTIONS_SCHEMA_ID}/ameya_analytics_datasets/${item_Id}`)
    }

    update = async (reqObj, item_Id, updatekey) => {
        await this.initialize();
        const { hashHex, etagRandomNumber } = await UpdateHeaders(updatekey);
        return AxiosObj.put(`/${this.accountId}/api/collection/${this.accountId}/user/private/cm/v1/${window.__ENV__.AMEYA_COLLECTIONS_SCHEMA_ID}/ameya_analytics_datasets/${item_Id}`, reqObj, {
            headers: {
                'etag-hash': hashHex,
                'etag-random-number': etagRandomNumber,
            }
        })
    }

    checkNameExistence = async (project_id, dataset_name) => {
        await this.initialize();
        const queryObj = [
            { field_name: "payload.project_id", field_value: project_id, operator: "eq" },
            { field_name: "payload.dataset_name", field_value: dataset_name, operator: "eq" }
        ]
        const queyString = encodeURIComponent(JSON.stringify(queryObj))
        return AxiosObj.get(`/${this.accountId}/api/collection/${this.accountId}/user/private/cm/v7/${window.__ENV__.AMEYA_COLLECTIONS_SCHEMA_ID}/ameya_analytics_datasetss?filters=${queyString}&include_detail=false&page_size=1000`)
    }

}

const AnalyticsDataSetsApi = new DpodAppFlyteApi();
export default AnalyticsDataSetsApi;